<section class="section-festivals">
  <div class="header-section">
    <h2 class="titre-section">Nos Festivals</h2>
    <p class="sous-titre">Explorez les dernières tendances ludiques</p>
  </div>
  
  <div class="liste-festivals">
    <div class="carte-festival" *ngFor="let fest of festivals">
      <div class="logo-wrapper">
        <img [src]="fest.logo" [alt]="fest.titre" (error)="fest.logo = ''" *ngIf="fest.logo">
        <h3 class="titre-fallback" *ngIf="!fest.logo">{{ fest.titre }}</h3>
      </div>
      
      <div class="ville">{{ fest.ville }}</div>
      <div class="lieu">{{ fest.lieu }}</div>
      
      <div class="infos-date">
        <span class="label">Chaque année en </span>
        <span class="mois">{{ fest.mois }}</span>
      </div>
      
      <a [href]="fest.lien" target="_blank" class="btn-plus">Plus d'infos !</a>
    </div>
  </div>
</section>